// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"StationDataTable_dataTable__2pcQV","tableHolder":"StationDataTable_tableHolder__3K9H8"};